import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 12v1.5l11 4.75v-2.1l-2.2-.9v-5l2.2-.9v-2.1L3 12zm7 2.62l-5.02-1.87L10 10.88v3.74zm8-10.37l-3 3h2v12.5h2V7.25h2l-3-3z"
}), 'TextRotateUp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TextRotateUp.js
// module id = 6719
// module chunks = 2